import api, { handleApiError, cachedGet } from './api';
import cacheService from './cacheService';

// Alle Artikel abrufen (mit Caching)
export const getArticles = async (frequentOnly = false, options = {}) => {
  try {
    const params = frequentOnly ? '?frequent_only=true' : '';
    const result = await cachedGet(
      `/articles${params}`,
      'cache_articles',
      options
    );
    return { 
      success: true, 
      data: result.data,
      fromCache: result.fromCache 
    };
  } catch (error) {
    // Wenn offline und kein Cache: Versuche AsyncStorage direkt
    if (error.message === 'No cached data available and offline') {
      const cached = await cacheService.getCachedArticles();
      if (cached) {
        return { 
          success: true, 
          data: cached, 
          fromCache: true,
          offline: true 
        };
      }
    }
    return { success: false, error: handleApiError(error) };
  }
};

// Vorschläge (häufig gekaufte Artikel) abrufen
export const getArticleSuggestions = async (limit = 20) => {
  try {
    const response = await api.get('/articles/suggestions', { params: { limit } });
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

// Einzelnen Artikel abrufen
export const getArticle = async (id) => {
  try {
    const response = await api.get(`/articles/${id}`);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

// Artikel mit Bild-URL laden (für Detail-Ansichten)
export const getArticleWithImage = async (id) => {
  try {
    const response = await api.get(`/articles/${id}/with-image`);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

// Artikel-Positionen abrufen
export const getArticlePositions = async (id) => {
  try {
    const response = await api.get(`/articles/${id}/positions`);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

// Artikel erstellen
export const createArticle = async (articleData) => {
  try {
    const response = await api.post('/articles', articleData);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

// Artikel bearbeiten
export const updateArticle = async (id, articleData) => {
  try {
    const response = await api.put(`/articles/${id}`, articleData);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

// Artikel löschen
export const deleteArticle = async (id) => {
  try {
    const response = await api.delete(`/articles/${id}`);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

// Artikel-Position für Laden aktualisieren
export const updateArticlePosition = async (articleId, storeId, position) => {
  try {
    const response = await api.post(`/articles/${articleId}/positions/${storeId}`, { position });
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: handleApiError(error) };
  }
};

